import React from 'react'
import { DraftListingInfoTip } from '../DraftListingInfoTip'
import { ListingTypeChangeCta } from '../../listingTypeChange/ListingTypeChangeCta'
import { useTranslation } from 'react-i18next'
import { Font } from 'is24-corecss'
import { FlowMetaData } from '../../../../../@types/types'

type InsertionStartInfoSectionProps = {
  isWebView?: boolean
  shouldShowDraftListingDescription?: boolean
  flowMetadata: FlowMetaData
}

export const InsertionStartInfoSection: React.FC<InsertionStartInfoSectionProps> = ({
  isWebView = false,
  shouldShowDraftListingDescription,
  flowMetadata,
}) => {
  const { t } = useTranslation()
  return (
    <>
      {shouldShowDraftListingDescription && <DraftListingInfoTip isWebView={isWebView} />}
      <div className={'margin-bottom-m'}>
        <ListingTypeChangeCta flowMetadata={flowMetadata} />
      </div>
      <Font className={'color-text-weak margin-bottom-m'}>{t('message.mandatory')}</Font>
    </>
  )
}
